import { Component, computed, effect, input, model, output } from '@angular/core';
import { SupportedTimezone, TimezoneDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '../../../edit-wrapper/form-edit-wrapper.component';
import { AuraInternationalizationTimezoneDisplayComponent } from '../display/internationalization-timezone-display.component';
import { AuraInternationalizationTimezoneFormComponent } from '../form/internationalization-timezone-form.component';

@Component({
  selector: 'aura-internationalization-timezone-edit',
  imports: [
    AuraEditWrapperComponent,
    AuraInternationalizationTimezoneFormComponent,
    AuraInternationalizationTimezoneDisplayComponent,
  ],
  templateUrl: './internationalization-timezone-edit.component.html',
})
export class AuraInternationalizationTimezoneEditComponent {
  initialTimezone = input.required<SupportedTimezone>();
  closeEditing = input<boolean>(false);
  isEditing = model<boolean>(false);
  saved = output<TimezoneDto>();

  currentTimezone = computed<TimezoneDto | null>(() => {
    const timezone = this.initialTimezone();
    return timezone ? { timezone } : null;
  });

  constructor() {
    effect(() => {
      if (this.closeEditing()) {
        this.isEditing.set(false);
      }
    });
  }
}
